<template>
    <b-modal id="viewGroupNotesModal" modal-class="view-group-notes-modal group-details-modal" centered size="md" hide-footer
        no-close-on-backdrop hide-header-close>
        <!-- Modal Header -->
        <template #modal-header>
            <div class="view-group-header d-flex justify-content-center align-items-center">
                <h5 class="modal-title">Group Notes</h5>
                <b-button variant="close-btn" class="btn-container" @click="closeModal">
                    <i class="fas fa-times"></i>
                </b-button>
            </div>
        </template>

        <b-container>
            <div class="notes-list-container">
                <div v-if="notes.length === 0" class="note-item text-center text-muted rounded py-3">
                    No notes available.
                </div>

                <div class="notes-scrollable">
                    <div v-for="note in sortedNotes" :key="note.anID" class="note-item mb-3 p-3 border rounded">
                        <!-- Note Content -->
                        <div class="note-content mb-2">{{ note.note }}</div>

                        <!-- Metadata & Attachment -->
                        <div class="d-flex justify-content-between align-items-end flex-wrap gap-2 small text-muted">
                            <div class="note-meta">
                                <div class="mb-1">Added By: <strong>{{ note.added_by }}</strong></div>
                                <div>Added On: <strong>{{ note.created_at }}</strong></div>
                            </div>

                            <div v-if="note.file" class="note-attachment">
                                <a class="doc-link" :href="note.file_url" target="_blank">
                                    <i class="fas fa-paperclip me-1"></i>Download Attachment
                                </a>
                            </div>
                            <div v-if="note.status" class="note-status mt-1"
                                :style="{ color: getStatusColor(note.status) }">
                                {{ note.formatted_status }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-container>
    </b-modal>
</template>

<script>
import Api from "@/resource/Api";

export default {
    name: "ViewGroupNotesModal",
    props: {
        isOpen: Boolean,
        row: { type: Object, default: () => { } },
    },
    data() {
        return {
            notes: [],
            statusColors: {
                1: '#FF0000',   // Urgent
                2: '#FF8000',   // Important
                3: '#FFC300',   // High
                4: '#800000',   // Medium
                5: '#0000FF',   // Low
                6: '#00A000',   // Information
                8: '#FF69B4',   // Special
            },
            nueraNoteUrl: process.env.VUE_APP_API_ADMIN,
        };
    },
    computed: {
        sortedNotes() {
            return this.notes.slice().sort((a, b) => new Date(b.addedOn) - new Date(a.addedOn));
        },
    },
    watch: {
        isOpen(status) {
            if(status) {
                this.getGroupNotes();
            }
        },
    },
    methods: {
        getStatusColor(status_id) {
            return this.statusColors[status_id] || '#6c757d';
        },
        closeModal() {
            this.$bvModal.hide("viewGroupNotesModal");
            this.$emit("close");
        },
        async getGroupNotes() {
            try {
                let loader = this.$loading.show();
                const url = `v2/notes/group/${this.row.group_id}`;
                Api.get(url)
                .then((data) => {
                    this.$notify("Note fetched successfully.");
                    this.notes = data?.data?.data || [];
                })
                .catch((err) => {
                    this.$notify(err.response?.data?.message || "Failed to fetch note.", "error");
                })
                .finally(() => {
                    loader.hide();
                });
            } catch (err) {
                this.$notify(
                    err?.response?.data?.message || "something went wrong",
                    "error"
                );
            }
        },
    },
};
</script>

<style>
    #viewGroupNotesModal .modal-header{
        display: flex !important;
        padding-bottom: 0;
    }
</style>

<style scoped>
.notes-scrollable {
    max-height: 400px;
    overflow-y: auto;
    padding-right: 5px;
}

.note-item {
    background-color: #f8f9fa;
    display: flex;
    flex-direction: column;
}

.note-item:last-child {
    margin-bottom: 0;
}

.note-content {
    white-space: pre-wrap;
    font-size: 0.95rem;
    margin-bottom: 0.5rem;
}

.note-meta div {
    line-height: 1.2;
}

.note-attachment a {
    color: #03c3ec;
    text-decoration: none;
    font-size: 0.9rem;
}

.note-attachment a:hover {
    text-decoration: underline;
}

@media (max-width: 576px) {}
</style>
